import { getChartOptions, series } from "../../../chart-with-stats/options"

export const leadGenerationTrendOptions = (
  containsData: boolean | undefined,
  chatLabels: any
): Highcharts.Options => ({
  ...getChartOptions(""),
  xAxis: {
    type: "category"
  },
  yAxis: containsData
    ? {
        lineWidth: 1,
        title: {
          text: "LEADS"
        }
      }
    : {
        gridLineWidth: 0,
        lineWidth: 1,
        title: {
          text: "LEADS"
        },
        tickInterval: 5,
        min: 5,
        max: 25
      },
  tooltip: {
    backgroundColor: "#42405A",
    borderColor: "#42405A",
    borderRadius: 5,
    shadow: false,
    style: {
      color: "#ffffff",
      fontSize: "12px",
      padding: "10px"
    },
    headerFormat: "",
    pointFormat: `<span style="font-weight: 700; padding-left: 5px">{point.name}</span><br/>
      <span>{point.y} leads</span><br/>`
  },
  plotOptions: {
    areaspline: {
      fillOpacity: 0.5,
      lineWidth: 2,
      lineColor: "#786ff6",
      fillColor: {
        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
        stops: [[0, "rgba(120, 111, 246, 0.3)"]]
      }
    }
  },
  series: [
    {
      ...series,
      type: "areaspline",
      data: chatLabels,
      marker: {
        enabled: false
      }
    }
  ]
})
